import FormQuestionType from '@opsbase/lib-form/FormQuestionType/FormQuestionType';
import getScore from '@opsbase/lib-form/helpers/getScore';
import getGradeColor from '@opsbase/lib-grading/getGradeColor';
import getPassStatusColor from '@opsbase/lib-grading/getPassStatusColor';
import GradingMethodType from '@opsbase/lib-grading/GradingMethodType';
import { passStatusLabel } from '@opsbase/lib-grading/PassStatus';
import scoreColor from '@opsbase/lib-grading/scoreColor';
import { opStatusColor, opStatusLabel } from '@opsbase/lib-op/OpStatus';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical/Vertical';
import capitalize from 'lodash/capitalize';
import moment from 'moment-timezone';
import React, { useContext } from 'react';
import { HashLink } from 'react-router-hash-link';
import GoogleMap from '../../../../../shared/UI/GoogleMap';
import useReportCSS from '../../useReportCSS';
import DetailsReportSwab from '../DetailsReportSwab';
import DetailsOpReportContext from './DetailsOpReportContext';
const dateFormat = 'ddd, MMM D YYYY';
const timeFormat = 'h:mm A';
function DateBit({ date }) {
    if (!date)
        return null;
    return (React.createElement(React.Fragment, null,
        moment(date).format(dateFormat),
        React.createElement("br", null),
        moment(date).format(timeFormat)));
}
export function DetailsOpReportSummary() {
    var _a, _b, _c, _d;
    const { op, def, issues } = useContext(DetailsOpReportContext);
    const myCss = useReportCSS(def.pdf);
    const completeTime = moment
        .duration(moment(op.actualComplete).diff(moment(op.actualStart), 'minutes'), 'minutes')
        .humanize();
    const noIssues = issues.length;
    const completedFor = [];
    if (op.organisation)
        completedFor.push(op.organisation.title);
    if (op.place)
        completedFor.push(op.place.title);
    const parsedForm = op.getParsedForm();
    const score = getScore(parsedForm);
    const perc = score.max ? (score.total / score.max) * 100 : null;
    const grade = op.grade ? op.organisation.settings.grades.find(it => it.key === op.grade) : null;
    let sections = (_b = (_a = op === null || op === void 0 ? void 0 : op.form) === null || _a === void 0 ? void 0 : _a.filter(q => q.type === FormQuestionType.SECTION)) !== null && _b !== void 0 ? _b : [];
    sections = sections.map(s => {
        return {
            ...s,
            score: getScore(parsedForm, parsedForm.questions[s.qId]),
        };
    });
    return (React.createElement("div", { className: myCss.page2 },
        React.createElement(Pane, null,
            React.createElement("div", { className: myCss.heading1 }, "Summary"),
            React.createElement("table", { className: myCss.table },
                React.createElement("tbody", null,
                    !op.isAdhoc && (React.createElement("tr", { className: myCss.row },
                        React.createElement("th", { className: myCss.heading + ' ' + myCss.left }, "Due to Start From"),
                        React.createElement("td", { className: myCss.data },
                            React.createElement(DateBit, { date: startFromInPlaceTimeZone(op) })),
                        React.createElement("th", { className: myCss.heading }, "Due Date"),
                        React.createElement("td", { className: myCss.data + ' ' + myCss.right },
                            React.createElement(DateBit, { date: completeByInPlaceTimeZone(op) })))),
                    React.createElement("tr", { className: myCss.row },
                        React.createElement("th", { className: myCss.heading + ' ' + myCss.left }, "Started"),
                        React.createElement("td", { className: myCss.data },
                            React.createElement(DateBit, { date: actualStartInPlaceTimeZone(op) })),
                        React.createElement("th", { className: myCss.heading }, "Completed"),
                        React.createElement("td", { className: myCss.data + ' ' + myCss.right },
                            React.createElement(DateBit, { date: actualCompleteInPlaceTimeZone(op) }))),
                    !!op.actualComplete && (React.createElement("tr", { className: myCss.row },
                        React.createElement("th", { className: myCss.heading + ' ' + myCss.left }, "Time to Complete"),
                        React.createElement("td", { colSpan: 3, className: myCss.data + ' ' + myCss.right }, capitalize(completeTime)))),
                    React.createElement("tr", { className: myCss.row },
                        React.createElement("th", { className: myCss.heading + ' ' + myCss.left }, "Op Status"),
                        React.createElement("td", { colSpan: 3, className: myCss.data + ' ' + myCss.right, style: { textTransform: 'capitalize' } },
                            React.createElement(DetailsReportSwab, { color: opStatusColor(op.status) }),
                            opStatusLabel(op.status))),
                    !!op.isScoreEnabled && (React.createElement("tr", { className: myCss.row },
                        React.createElement("th", { className: myCss.heading + ' ' + myCss.left }, "Score"),
                        React.createElement("td", { colSpan: 3, className: myCss.data + ' ' + myCss.right, style: { textTransform: 'capitalize' } },
                            React.createElement(DetailsReportSwab, { color: scoreColor(perc) }),
                            score.total + '/' + score.max,
                            React.createElement(Vertical, { gutter: true, paddingY: true }, sections.map((s) => {
                                return (React.createElement(HashLink, { key: 'section_' + s.qId + '_home', id: 'section_' + s.qId + '_home', smooth: true, to: '#Question_' + s.qId }, s.title +
                                    ' (' +
                                    Math.round((((s.score.total || 0) /
                                        (s.score.max || 1)) *
                                        100 +
                                        Number.EPSILON) *
                                        100) /
                                        100 +
                                    '%)'));
                            }))))),
                    ((_c = op.gradingMethod) === null || _c === void 0 ? void 0 : _c.gradingMethodType) === GradingMethodType.CALCULATED && (React.createElement("tr", { className: myCss.row },
                        React.createElement("th", { className: myCss.heading + ' ' + myCss.left }, "Grade"),
                        React.createElement("td", { colSpan: 3, className: myCss.data + ' ' + myCss.right, style: { textTransform: 'capitalize' } },
                            React.createElement(DetailsReportSwab, { color: getGradeColor(grade === null || grade === void 0 ? void 0 : grade.color) }), grade === null || grade === void 0 ? void 0 :
                            grade.title))),
                    ((_d = op.gradingMethod) === null || _d === void 0 ? void 0 : _d.gradingMethodType) !== GradingMethodType.NONE && (React.createElement("tr", { className: myCss.row },
                        React.createElement("th", { className: myCss.heading + ' ' + myCss.left }, "Pass Status"),
                        React.createElement("td", { colSpan: 3, className: myCss.data + ' ' + myCss.right, style: { textTransform: 'capitalize' } },
                            React.createElement(DetailsReportSwab, { color: getPassStatusColor(op.passFailStatus) }),
                            passStatusLabel(op.passFailStatus)))),
                    React.createElement("tr", { className: myCss.row },
                        React.createElement("th", { className: myCss.heading + ' ' + myCss.left }, "Issues Raised"),
                        React.createElement("td", { colSpan: 3, className: myCss.data + ' ' + myCss.right }, noIssues > 0 ? noIssues : 'None')),
                    React.createElement("tr", { className: myCss.row },
                        React.createElement("th", { className: myCss.heading + ' ' + myCss.left }, "Ad-Hoc"),
                        React.createElement("td", { colSpan: 3, className: myCss.data + ' ' + myCss.right }, op.isAdhoc || !op.startFrom ? 'Yes' : 'No')),
                    React.createElement("tr", { className: myCss.row },
                        React.createElement("th", { className: myCss.heading + ' ' + myCss.left }, "Started By"),
                        React.createElement("td", { colSpan: 3, className: myCss.data + ' ' + myCss.right }, !!op.startedBy ? op.startedBy.title : '-')),
                    React.createElement("tr", { className: myCss.row },
                        React.createElement("th", { className: myCss.heading + ' ' + myCss.left }, "Completed By"),
                        React.createElement("td", { colSpan: 3, className: myCss.data + ' ' + myCss.right }, !!op.submittedBy ? op.submittedBy.title : '')),
                    React.createElement("tr", { className: myCss.row },
                        React.createElement("th", { className: myCss.heading + ' ' + myCss.left }, "Completed For"),
                        React.createElement("td", { colSpan: 3, className: myCss.data + ' ' + myCss.right }, completedFor.join(', '))),
                    !!op.opPerformedLocation && (React.createElement("tr", { className: myCss.row },
                        React.createElement("th", { className: myCss.heading + ' ' + myCss.left }, "Completed At"),
                        React.createElement("td", { colSpan: 3, className: myCss.data + ' ' + myCss.right },
                            React.createElement(GoogleMap, { staticMap: true, location: op.opPerformedLocation, width: 800, height: 200 })))))))));
}
export default DetailsOpReportSummary;
function actualCompleteInPlaceTimeZone(op) {
    var _a;
    return op.actualComplete
        ? ((_a = op.place) === null || _a === void 0 ? void 0 : _a.timezone)
            ? moment(op.actualComplete).tz(op.place.timezone)
            : moment(op.actualComplete)
        : undefined;
}
function actualStartInPlaceTimeZone(op) {
    var _a;
    return op.actualStart
        ? ((_a = op.place) === null || _a === void 0 ? void 0 : _a.timezone)
            ? moment(op.actualStart).tz(op.place.timezone)
            : moment(op.actualStart)
        : undefined;
}
function startFromInPlaceTimeZone(op) {
    var _a;
    return op.startFrom
        ? ((_a = op.place) === null || _a === void 0 ? void 0 : _a.timezone)
            ? moment(op.startFrom).tz(op.place.timezone)
            : moment(op.startFrom)
        : undefined;
}
function completeByInPlaceTimeZone(op) {
    var _a;
    return op.completeBy
        ? ((_a = op.place) === null || _a === void 0 ? void 0 : _a.timezone)
            ? moment(op.completeBy).tz(op.place.timezone)
            : moment(op.completeBy)
        : undefined;
}
